/**
 * @returns {Promise<string>}
 */
const fetchAppToken = async () =>
  new Promise((resolve) => VSS.getAppToken().then(({ token }) => resolve(token)));

export default fetchAppToken;
